import React, { memo, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { Challenge, Classable, Entity, HasChildren, KeyIssue, Shapeable, Topic, Trend } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityOutlineNumberRank } from '@shapeable/utils';
import { SvgEntityNavigator, useTrends, useEntityNavigatorNodes } from '@shapeable/ui';

const cls = classNames('trends-navigator-map');

// -------- Types -------->

// -------- Props -------->

export type TrendsNavigatorMapProps = Classable & HasChildren & {
  items?: Entity[];
}

export const TrendsNavigatorMapDefaultProps: TrendsNavigatorMapProps = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  `,
});

// -------- Components -------->

const My = {
  Container: styled(SvgEntityNavigator)<ContainerProps>`${ContainerStyles}`,
};

export const TrendsNavigatorMap: React.FC<TrendsNavigatorMapProps> = memo((props) => {
  const { className, items } = props;

  const trends = useTrends();

  const nodes = useEntityNavigatorNodes<Trend, Topic>({
    items: trends,
    fieldNameChildren: 'topics',
    sort: entityOutlineNumberRank,
    sortChildren: entityOutlineNumberRank,
  });
  
  return (
    <My.Container 
      initialViewBox={
      {
          "x": -17.45375733976842,
          "y": -13.13102227490805,
          "width": 863.1578947368422,
          "height": 852.6315789473684,
          "zoom": 1
      }
      }
      nodes={nodes} 
      padding={40}
      className={cls.name(className)} 
    />
  )
});

/* @ts-ignore */
TrendsNavigatorMap.cls = cls;
TrendsNavigatorMap.defaultProps = TrendsNavigatorMapDefaultProps;